import React from 'react'
import { Helmet } from 'react-helmet'
// import Getintouch2 from '../component/Getintouch2'
import FooterNew from '../component/FooterNew'
import Menu from '../component/Menu'
import HeroSection from '../component/HeroSection'
import ProcessSection from '../component/ProcessSection'

import bgimg from '../images/tech ai hero bg.webp'
import PracticalAI from '../component/PracticalAI'

import practicalai1 from '../images/Enterprise Knowledge Intelligence.webp';
import practicalai2 from '../images/AI Agents & Copilots.webp';
import practicalai3 from '../images/Intelligent Workflow Automation.webp';
import practicalai4 from '../images/Decision Intelligence.webp';
import practicalai5 from '../images/Custom Software Products.webp';
import practicalai6 from '../images/Personalised App Stores.webp';
import ApproachSection from '../component/ApproachSection'

import Technicalview from '../images/Technical view b.webp';
import Opportunity from '../component/Opportunity'
import ServicesValue from '../component/ServicesValue'
import AiCta from '../component/AiCta'
import SolutionPatternsSlider from '../component/SolutionPatternsSlider'

import patternimg1 from '../images/pattern-1.webp';
import patternimg2 from '../images/pattern-2.webp';
import patternimg3 from '../images/pattern-3.webp';
import patternimg4 from '../images/pattern-4.webp';
// import patternimg5 from '../images/pattern-5.webp';
// import patternimg6 from '../images/pattern-6.webp';
// import patternimg7 from '../images/pattern-7.webp';



const TechAndAi = ({setBlank}) => {

const heroData = {
 
  backgroundImage: bgimg,

  backgroundAlt: "AI-powered technology",

  overlay: {
    enabled: true,
    opacity: 0.65
  },


  content: {
    eyebrow: "Human expertise. AI-accelerated",

    heading: [
      {
        text: "Intelligence,",
        highlight: false
      },
      {
        text: " delivered.",
        highlight: true
      }
    ],

    description:
      "We help organisations identify high-value AI opportunities, connect fragmented data and knowledge, and build practical AI solutions that improve how teams work and make decisions."
  },

  /*
   * ============================
   * BUTTONS
   * ============================
   */

  buttons: [
    {
      id: 1,
      label: "Discuss your AI roadmap",
      href: "#contact",
      style: "primary"
    },

    {
      id: 2,
      label: "Explore our approach",
      href: "#approach",
      style: "secondary"
    }
  ]
};

const practicalAIData = {
  sectionLabel: "WHAT WE BUILD",

  heading: "Practical AI, built around the way your organisation works.",

  cards: [
    {
      id: 1,
      title: "Enterprise Knowledge Intelligence",
      description:
        "Permission-aware search and contextual retrieval across organisational knowledge.",
      image: practicalai1,
      alt: "Enterprise Knowledge Intelligence"
    },
    {
      id: 2,
      title: "AI Agents <br />& Copilots",
      description:
        "Assistants that support research, analysis, reporting, coordination, and execution.",
      image: practicalai2,
      alt: "AI Agents and Copilots"
    },
    {
      id: 3,
      title: "Intelligent Workflow Automation",
      description:
        "AI-enabled workflows with approvals, controls, and human review.",
      image: practicalai3,
      alt: "Intelligent Workflow Automation"
    },
    {
      id: 4,
      title: "Decision <br />Intelligence",
      description:
        "Predictive insight, exception identification, and decision-support applications.",
      image: practicalai4,
      alt: "Decision Intelligence"
    },
    {
      id: 5,
      title: "Custom Software <br />Products",
      description:
        "Design and build bespoke business applications tailored to operational, customer-facing, analytical, and strategic requirements.",
      image: practicalai5,
      alt: "Custom Software Products"
    },
    {
      id: 6,
      title: "Personalised App <br />Stores",
      description:
        "Develop tailored ecosystems of lightweight business applications, automation tools, AI solutions, dashboards, and operational utilities.",
      image: practicalai6,
      alt: "Personalised App Stores"
    }
  ]
};


const processData = {
  sectionLabel: "THE PROCESS",

  heading: "From opportunity to enterprise-wide adoption",

  cards: [
    {
      id: 1,
      number: "01",
      title: "Assess",
      subtitle: "Diagnose + Discover",
      description:
        "Understand the organisation’s systems, data maturity, workflows, AI readiness, and highest-value opportunities.",

      points: [
        "Current-state assessment",
        "Workflow and use-case discovery",
        "Value, feasibility, and priority"
      ]
    },

    {
      id: 2,
      number: "02",
      title: "Accelerate",
      subtitle: "Design + Build",
      description:
        "Redesign priority workflows and implement practical AI solutions on trusted data and knowledge.",

      points: [
        "Future workflow and control design",
        "Agents, copilots, automations, and apps",
        "Integration with existing systems"
      ]
    },

    {
      id: 3,
      number: "03",
      title: "Amplify",
      subtitle: "Scale",
      description:
        "Expand what works across the organisation, with the ownership and operating model needed to sustain it.",

      points: [
        "Expansion to new teams and use cases",
        "Operating model and ownership",
        "Value tracked against the business case"
      ]
    }
  ]
};

const approachData = {
  sectionLabel: "THE APPROACH",

  heading: "From fragmented information to AI-powered execution",

  tabs: {
    business: {
      label: "Business view",

      cards: [
        {
          id: 1,
          number: "01",
          label: "FOUNDATION",
          title: "Trusted Data Foundation",
          description:
            "Create reliable analytical foundations from fragmented data and information.",

          tags: [
            "Data engineering",
            "Data clean-up",
            "Transformation",
            "Analytics",
            "BI",
            "Analytical models"
          ],

          theme: "teal"
        },

        {
          id: 2,
          number: "02",
          label: "INTELLIGENCE",
          title: "Intelligence Layer",
          description:
            "Connect projects, CRM, files, emails, knowledge assets, and historical work into governed, searchable, contextual, and reusable organisational intelligence.",

          tags: [
            "Organisational memory",
            "Permission-aware access",
            "Searchable context",
            "Knowledge retrieval",
            "System orchestration"
          ],

          theme: "orange"
        },

        {
          id: 3,
          number: "03",
          label: "DELIVERY",
          title: "Software Engineering & Execution",
          description:
            "Turn connected intelligence into software solutions, custom applications, automations, and internal software ecosystems that support and automate real work.",

          tags: [
            "Software engineering",
            "Software solutions",
            "Custom applications",
            "Automations",
            "Internal software ecosystems",
            "AI agents & copilots"
          ],

          theme: "pink"
        }
      ]
    },

    technical: {
      label: "Technical view",

      // For now the technical view is just an image.
      image: Technicalview,

      imageAlt: "Technical view of AI-powered execution"
    }
  }
};


const opportunityData = {
  sectionLabel: "THE OPPORTUNITY",

  heading: [
    {
      text: "Most organisations",
      highlight: false
    },
    {
      text: "do not have an AI",
      highlight: false
    },
    {
      text: "problem. They have a",
      highlight: false
    },
    {
      text: "connection problem.",
      highlight: false
    }
  ],

  content: {
    paragraphs: [
      "Data sits in operational systems. Knowledge sits in files, emails, project histories, and people’s experience. Workflows cross multiple tools and teams.",

      "We connect these components into an intelligence foundation that AI can use securely and practically."
    ],

    tags: [
      "Projects",
      "CRM",
      "Files",
      "Emails",
      "",
      "Operational systems",
      "Knowledge",
      "Historical work"
    ]
  }
};


const servicesData = {
  sectionLabel: "ACROSS OUR SERVICES",

  heading: [
    {
      text: "Where AI creates the most value",
      highlight: false
    },
    {
      text: "for our clients",
      highlight: false
    }
  ],

  activeCard: 1,

  cards: [
    {
      id: 0,
      title: "Investment Advisory",
      description: "",
      image: "/images/investment-advisory.jpg"
    },

    {
      id: 1,
      title: "Management Consulting",
      description:
        "Redesign repetitive processes and deploy intelligent workflows across business functions.",
      image: "/images/management-consulting.jpg"
    },

    {
      id: 2,
      title: "AI & Data Solutions",
      description: "",
      image: "/images/ai-data-solutions.jpg"
    }
  ]
};

const aiCtaData = {
  title: ["Ready To Turn AI Ambition", "Into Working Solutions?"],
  description: [
    "Start with an assessment of your systems, knowledge, data, and high-value workflows.",
    "We will help you define the roadmap and move from opportunity to implementation.",
  ],
  button: {
    label: "Discuss Your AI Roadmap",
    href: "#",
  },
  accent: {
    leftColor: "#20b5b0",
    rightColor: "#e62d8b",
  },
  colors: {
    background: "linear-gradient(180deg, rgba(5, 48, 77, 0.71) 11.88%, rgba(5, 48, 77, 0) 108.17%), #011427",
    title: "#ffffff",
    description: "#e6edf2",
    buttonBackground: "linear-gradient(180deg, #01C6B2 0%, #048D7F 128.35%)",
    buttonText: "#ffffff",
    buttonBorder: "#FFFFFF",
    boxShadow: "0px 2px 8px 0px #00000040"

  },
};



const solutionSliderData =[
  {
    "id": "knowledge-intelligence",
    "category": "Knowledge Intelligence",
    "title": "Enterprise Knowledge Intelligence Platform",
    "audience": "For delivery, bid, and research teams",
    "icon": patternimg1,
    "challenge": "Knowledge scattered across files, email, CRM, and projects.",
    "whatWeBuild": "A permission-aware AI search and retrieval layer.",
    "businessImpact": "Faster discovery, stronger reuse, and more consistent outputs.",
    "btnText":"Learn more",
    "btnLink":"#"
  },
  {
    "id": "research-automation",
    "category": "Research Automation",
    "title": "AI-Assisted Research Workflow",
    "audience": "For research and strategy teams",
    "icon": patternimg2,
    "challenge": "Market and competitor intelligence gathered by hand.",
    "whatWeBuild": "Workflows for research, synthesis, and cited first drafts.",
    "businessImpact": "Faster turnaround with stronger depth and traceability.",
    "btnText":"Learn more",
    "btnLink":"#"
  },
  {
    "id": "financial-intelligence",
    "category": "Financial Intelligence",
    "title": "Financial Reporting & Analysis Assistant",
    "audience": "For finance, FP&A, and CFO teams",
    "icon": patternimg3,
    "challenge": "KPI reviews, model checks, and commentary eat analyst time.",
    "whatWeBuild": "AI-supported review with automated exception flagging.",
    "businessImpact": "Sharper management reporting and faster review cycles.",
    "btnText":"Learn more",
    "btnLink":"#"
  },
  {
    "id": "PMO Intelligence",
    "category": "PMO Intelligence",
    "title": "Project Intelligence & PMO Command Hub",
    "audience": "For PMO and delivery leads",
    "icon": patternimg4,
    "challenge": "Updates, risks, and reporting spread across teams.",
    "whatWeBuild": "Workflows that summarise, flag risks, and report.",
    "businessImpact": "Better visibility, governance, and communication.",
    "btnText":"Learn more",
    "btnLink":"#"
  },
  // {
  //   "id": "Investment Intelligence",
  //   "category": "Investment Intelligence",
  //   "title": "Deal Screening & Diligence Copilot",
  //   "audience": "For investment and diligence teams",
  //   "icon": patternimg5,
  //   "challenge": "Large document sets to screen under tight timelines.",
  //   "whatWeBuild": "Term and risk extraction with cited screening notes.",
  //   "businessImpact": "Wider screening coverage and more consistent diligence."
  // },
  // {
  //   "id": "Revenue Enablement",
  //   "category": "Revenue Enablement",
  //   "title": "Proposal & Bid Response Accelerator",
  //   "audience": "For sales and bid teams",
  //   "icon": patternimg6,
  //   "challenge": "Every proposal rebuilds content that already exists.",
  //   "whatWeBuild": "Retrieval across past bids, credentials, and CVs.",
  //   "businessImpact": "Faster first drafts and stronger reuse of proven material."
  // },
  // {
  //   "id": "Document Intelligence",
  //   "category": "Document Intelligence",
  //   "title": "Contract & Document Review Assistant",
  //   "audience": "For legal and commercial teams",
  //   "icon": patternimg7,
  //   "challenge": "Manual reading, with precedent held by individuals.",
  //   "whatWeBuild": "Clause extraction, deviation flags, and review summaries.",
  //   "businessImpact": "Shorter review cycles with clearer risk visibility."
  // }
]


  return (
        <>
        <Helmet>
            <title>Tech And Ai</title>
             <meta property="og:title" content="Tech And Ai" />
             <meta name='og:description' content='Tech And Ai' />
             <meta name='keywords' content='Tech, Ai, Technology' />
        </Helmet>
        <Menu setBlank={setBlank} />
        <HeroSection data = {heroData} />
        <Opportunity data = {opportunityData} />
        <ProcessSection data = {processData} />
        <PracticalAI data = {practicalAIData} />
        <ApproachSection data={approachData} />
        <ServicesValue data={servicesData} setBlank={setBlank} />
        <SolutionPatternsSlider data={solutionSliderData} />
        <AiCta data={aiCtaData} />
        {/* <Getintouch2 /> */}
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default TechAndAi